import { create } from 'zustand'

interface HeaderStore {
  itemIndex: number
  changeIndex: (index: number) => void
}

export const useHeaderStore = create<HeaderStore>((set) => ({
  itemIndex: -1,
  changeIndex: (index) => set(() => ({ itemIndex: index >= 0 ? index : -1 })),
}))
